import { useEffect, useState } from 'react';
import api from './api';

// The admin's feature switches (Admin → Configuración → Funciones), as the app reads them. The
// server refuses what is switched off (503, services/feature_flags.py); this hides or disables the
// way in first and says why, with the same words.

export const PAUSED = {
  help_requests: 'La ayuda vecinal está en pausa temporalmente. Las ayudas en curso siguen funcionando.',
  incidencias: 'Las incidencias nuevas y los comentarios están en pausa temporalmente.',
  ai_chat: 'Torre está en pausa temporalmente. Vuelve a intentarlo más tarde.',
  zbe_plate_checker: 'La consulta de etiqueta por matrícula está en pausa temporalmente.',
  live_sports: 'Los marcadores en directo están en pausa temporalmente.',
};

const TTL_MS = 60 * 1000;
let cached = null;      // { at, flags }
let inflight = null;

/** Flags from the server, shared by every component, re-read at most once a minute. Until they
 *  arrive, and if they cannot be read, everything counts as on: the server still refuses. */
export function loadFlags(now = Date.now()) {
  if (cached && now - cached.at < TTL_MS) return Promise.resolve(cached.flags);
  if (!inflight) {
    inflight = api.get('/admin/config/flags/public')
      .then((res) => { cached = { at: Date.now(), flags: res.data || {} }; return cached.flags; })
      .catch(() => (cached ? cached.flags : {}))
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** true unless the admin switched `key` off. */
export function isOn(flags, key) {
  return !flags || flags[key] !== false;
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState(cached ? cached.flags : null);
  useEffect(() => {
    let live = true;
    loadFlags().then((f) => { if (live) setFlags(f); });
    return () => { live = false; };
  }, []);
  return flags;
}

export function _resetForTests() {
  cached = null;
  inflight = null;
}
